import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { userRoles } from '@/mocks/jiuchou-architecture';

export default function UserLayer() {
  return (
    <section className="w-full bg-background-50 py-16 md:py-24">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="第一层 · 用户与角色层"
            title="九畴云铺用户生态"
            subtitle="消费者、云社员、云店长、云创客、供应链、商家与县域运营主体，共同构成县域数字商业的用户生态。"
          />
        </Reveal>

        <Reveal delay={100}>
          <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {userRoles.map((u, i) => (
              <div
                key={u.name}
                className={`p-6 rounded-lg border ${
                  i === 1 ? 'border-primary-300 bg-primary-50' : 'border-background-200 bg-background-100'
                }`}
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 rounded-lg bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className={`${u.icon} text-accent-700 text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950">{u.name}</h3>
                </div>
                <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{u.desc}</p>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}